// frontend/modules/customer-category/views/CustomerCategoryCreateView.tsx
import React from 'react';
import { Card, Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@/components/common/ThemeProvider';
import CustomerCategoryPageForm from '../components/CustomerCategoryPageForm';
import { CustomerCategoryDTO } from '@/shared/api/model';
import { useCustomerCategories } from '../hooks/useCustomerCategories';

const { Title } = Typography;

const CustomerCategoryCreateView: React.FC = () => {
    const { dark } = useTheme();
    const navigate = useNavigate();
    const { createCategory } = useCustomerCategories();

    const handleSubmit = async (formData: CustomerCategoryDTO) => {
        try {
            await createCategory(formData);
            navigate('/admin/general-config/customer-categories');
        } catch (error) {
            console.error('Error creating customer category:', error);
            throw error;
        }
    };

    const handleCancel = () => {
        navigate('/admin/general-config/customer-categories');
    };

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    <Button
                        icon={<ArrowLeftOutlined />}
                        onClick={handleCancel}
                        type="text"
                    >
                        Back to Categories
                    </Button>
                    <Title level={2} className={`mb-0 ${dark ? 'text-white' : ''}`}>
                        Create Customer Category
                    </Title>
                </div>
            </div>

            <Card className={dark ? 'bg-gray-800' : ''}>
                <CustomerCategoryPageForm
                    mode="create"
                    initialData={null}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                />
            </Card>
        </div>
    );
};

export default CustomerCategoryCreateView;
